import React, { useEffect, useRef, useState } from 'react';
import { ChevronRightIcon, LoaderCircleIcon, LocateFixedIcon, MapPinIcon } from 'lucide-react';
import { addresses } from '../../data/profil';
interface LocationPickerProps {
  onPick: (address: string, source: 'position' | 'profil') => void;
  /** Adresse renvoyée par la géolocalisation simulée. */
  detectedAddress: string;
}
export function LocationPicker({
  onPick,
  detectedAddress
}: LocationPickerProps) {
  const [locating, setLocating] = useState(false);
  const timerRef = useRef<number | null>(null);
  useEffect(() => () => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
  }, []);
  const locate = () => {
    if (locating) return;
    setLocating(true);
    timerRef.current = window.setTimeout(() => {
      setLocating(false);
      onPick(detectedAddress, 'position');
    }, 900);
  };
  return <div className="mt-4 space-y-2" data-id="element-906" data-mp="xp6412awkx68">
      <button type="button" onClick={locate} aria-busy={locating} className="flex w-full items-center gap-3 rounded-2xl bg-ville-navy px-4 py-3 text-left text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-907" data-mp="xo4vp5l9uos7">
        <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white/15" aria-hidden="true" data-id="element-908" data-mp="3w43uus6de5fa">
          {locating ? <LoaderCircleIcon className="h-4 w-4 animate-spin" data-id="element-909" data-mp="3r62ck9grqa4v" /> : <LocateFixedIcon className="h-4 w-4" data-id="element-910" data-mp="3mcq0eyt9zvt0" />}
        </span>
        <span className="min-w-0 flex-1" data-id="element-911" data-mp="3heeomijf7b85">
          <span className="block text-sm font-bold" data-id="element-912" data-mp="3hf7oczjyp0gs">
            {locating ? 'Localisation en cours…' : 'Utiliser ma position actuelle'}
          </span>
          <span className="block text-xs text-white/60" data-id="element-913" data-mp="38dq9fkiaj4to">
            {locating ? 'Recherche du point le plus proche' : 'Le plus rapide si vous êtes sur place'}
          </span>
        </span>
      </button>

      <ul className="space-y-2" data-id="element-914" data-mp="2tqrma1qguwkr">
        {addresses.map(address => <li key={address.id} data-id="element-915" data-mp="2xsweqx56hn5t">
            <button type="button" onClick={() => onPick(address.street, 'profil')} className="group flex w-full items-center gap-3 rounded-2xl border border-slate-200 px-4 py-3 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-916" data-mp="2xt4qumth8ofy">
              <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-ville-mist text-ville-deep" aria-hidden="true" data-id="element-917" data-mp="3hfu2r69d6jdo">
                <MapPinIcon className="h-4 w-4" data-id="element-918" data-mp="37qajhzhqonia" />
              </span>
              <span className="min-w-0 flex-1" data-id="element-919" data-mp="3vgmz7wj87ojf">
                <span className="flex flex-wrap items-center gap-2" data-id="element-920" data-mp="3vfv38klpvosm">
                  <span className="text-sm font-bold text-ville-navy" data-id="element-921" data-mp="42h9xx1wb57b">{address.street}</span>
                  {address.primary && <span className="rounded-full bg-ville-lime px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-ville-navy" data-id="element-922" data-mp="1oqteypw4sfrl">
                      Principale
                    </span>}
                </span>
                <span className="block text-xs text-slate-500" data-id="element-923" data-mp="1tj2ztrie2pn0">
                  {address.label} · {address.city}
                </span>
              </span>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-slate-300 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-924" data-mp="15u1z6qfssisa" />
            </button>
          </li>)}
      </ul>

      <p className="pt-1 text-xs text-slate-500" data-id="element-925" data-mp="19uu8tksl0pp3">
        Ailleurs dans la ville ? Écrivez l’adresse ou l’intersection dans le champ ci-dessous.
      </p>
    </div>;
}